import React, { use, useEffect, useRef, useState } from 'react'
import { sendEmail } from '../api/company';
import Loader from '../components/Loader';
import PopupModal from '../components/PopupModal';
import $ from 'jquery';
import 'select2/dist/css/select2.min.css';
import 'select2';

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useNavigate } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import { list, getUserByGID, deleteGroupByID } from '../api/group';

export default function SendEmail() {

    const selectRef = useRef();
    const { user } = useUserStore();
    const navigate = useNavigate();
    const [editorData, setEditorData] = useState("");
    const [loading, setLoading] = useState(false);
    const [companyName, setCompanyName] = useState("0");
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");

    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [onConfirmAction, setOnConfirmAction] = useState(null);

    const [option, setOption] = useState([{
        "id": "0",
        "companyName": "Please select company"
    }]);

    const [scopeOptions, setScopeOptions] = useState([]);
    const [groupList, setGroupList] = useState([]);

    useEffect(() => {
        setGroupList(scopeOptions);
    }, [scopeOptions]);

    const getGroupList = async () => {
        setLoading(true);
        let data = await list(user.db);
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setScopeOptions([{ id: 0, title: "Please select group" },
            ...data.data.data.map(obj => ({
                ...obj,
                title: `${obj.title}`,
                userList: obj.userList || [],
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            })).sort((a, b) =>
                a.title.localeCompare(b.title, undefined, { sensitivity: "base" })
            )
            ]);
        } else {
            setScopeOptions([{ id: 0, title: "Please select group" }]);
        }
    }
    useEffect(() => {
        getGroupList();
    }, []);

    const [formData, setFormData] = useState({
        group: "",
    });

    const handleGroupClick = () => {
        navigate('/group');
    }


    useEffect(() => {

        const $select = $(selectRef.current);

        // Convert group string into array of selected values
        const selected = formData.group ? formData.group.split('+') : [];

        $select.val(selected).trigger('change'); // Set selected values


        $select.select2();
        $select.on('change', function (e) {
            // const name = e.target.name;
            // const selectedValues = $(this).val(); // array of selected values

            // let selectedData = scopeOptions.filter(opt => selectedValues.includes(opt.value));
            // const result = selectedData.map(item => item.value).join('+');
        });
        return () => {
            $select.select2('destroy');
        };
    }, [formData.group]);

    const refreshData = () => {
        //const selectedValues = $(selectRef.current).val();
        console.log("scopeOptions", scopeOptions);
    };
    useEffect(() => {
        console.log("AAAAAAAAAA", groupList);
    }, [formData.group]);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = `${process.env.PUBLIC_URL}/assets/js/misc.js`; // e.g., '/scripts/some-lib.js'
        script.async = true;
        document.body.appendChild(script);
        return () => {
            // document.getElementById('dynamic-js')?.remove();
        };
    }, []);


    const getCompanyList = async () => {
        setLoading(true);
        let data = await list();
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setOption([{ id: 0, companyName: "Please select company" },
            ...data.data.data.map(obj => ({
                ...obj,
                companyName: `${obj.companyName} (${obj?.clientID || "Test "})`,
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            })).sort((a, b) =>
                a.companyName.localeCompare(b.companyName, undefined, { sensitivity: "base" })
            )
            ]);
        }
    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        getCompanyList();
    }, []);

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);


    const handleChange = async (e) => {
        const { value, } = e.target;
        setCompanyName(value);


    }
    const [sysOptions, setSYSOptions] = useState([
        { label: "TDR", value: "Tdr", checked: false, className: "form-check-primary" },
        { label: "Production", value: "pro", checked: false, className: "form-check-success" },
    ]);


    const submitData = async () => {
        console.log("editorData", editorData);

        const res = await sendEmail({
            "message": "<h2>Hello 👋</h2><p>This is a <strong>test</strong> email</p>",
            "subject": "Test Email",
            "email": "mdaramari@gmail.com",
            "bcc": [
                "divyesh.trambadia@gmail.com"
            ]
        })
        console.log(res);
    }


    const [groupFormData, setGroupFormData] = useState({
        groupName: '',
        emails: ''
    });

    const [groupErrors, setGroupErrors] = useState({
        groupName: '',
        emails: ''
    });

    const handleChangeGroup = (e) => {
        const { name, value } = e.target;
        setGroupFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user types
        setGroupErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    const handleGroupSubmit = () => {
        let newGroupErrors = {};

        if (!groupFormData.groupName.trim()) {
            newGroupErrors.groupName = 'Group Name is required';
        }

        if (!groupFormData.emails.trim()) {
            newGroupErrors.emails = 'Emails are required';
        }

        setGroupErrors(newGroupErrors);

        // If no errors, save the data
        if (Object.keys(newGroupErrors).length === 0) {
            console.log('Saving data...', formData);
            alert('Data saved successfully!');
            // Optionally, reset form
            // setFormData({ groupName: '', message: '' });
        }
    };

    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
                onConfirm={onConfirmAction}
            />
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}
                <div className="page-header">
                    <h3 className="page-title"> Send Email </h3>
                    {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <button type="button" onClick={handleGroupClick} className="btn btn-primary me-2">Group</button>

                        </ol>
                    </nav>
                </div>

                <div className="row">
                    <div className="page-header">
                        {/* <h3 className="page-title"> Send email setting  </h3> */}
                    </div>
                </div>
                <div className="row">

                    <div className="col-md-8 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h4 className="card-title mb-0">Send Email</h4>
                                    <button className="btn btn-primary">Send</button>
                                </div>


                                <div className="form-group">
                                    <label htmlFor="exampleSelectGender">Users</label>
                                    <select className="form-select" id="exampleSelectGender" name="companyName" value={companyName} onChange={handleChange}>
                                        {option
                                            .filter((obj) => obj.id !== "")
                                            .map((obj) => (
                                                <option key={obj.id} value={obj.id} cStatus={obj.status}>
                                                    {obj.companyName}
                                                </option>
                                            ))}

                                    </select>
                                </div>
                                <div className="col-md-6">
                                    {/* <div className="form-group d-flex align-items-center gap-2">
                                        {sysOptions.map((option, index) => (
                                            <div className={`form-check ${option.className}`} key={option.value} >
                                                <label className="form-check-label">
                                                    <input
                                                        type="checkbox"
                                                        name="systemList"
                                                        className="form-check-input"
                                                        checked={option.checked}
                                                        data-index={index}
                                                    //onChange={() => handleChange(index)}
                                                    // onChange={handleChange}
                                                    />{" "}
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div> */}
                                </div>

                                <div className="form-group">
                                    <label>Select Group</label>

                                    <select
                                        ref={selectRef}
                                        name="group"
                                        className="js-example-basic-multiple"
                                        multiple
                                        style={{ width: '100%' }}
                                    >
                                        {scopeOptions.map((opt) => (
                                            <option key={opt.title} value={opt.title}>
                                                {opt.title}
                                            </option>
                                        ))}
                                    </select>

                                    {/* {errors.group && <span className="text-danger">{errors.group}</span>} */}
                                </div>

                                <div className="form-group">
                                    <label >Enter Manual Email</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="FullName"
                                        // value={formData.FullName}
                                        // onChange={handleChange}
                                        placeholder="Full Name" />
                                    {/* {errors.FullName && <span className="text-danger">{errors.FullName}</span>} */}
                                </div>

                                <div className="form-group">
                                    <label >Subject</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="FullName"
                                        // value={formData.FullName}
                                        // onChange={handleChange}
                                        placeholder="Full Name" />
                                    {/* {errors.FullName && <span className="text-danger">{errors.FullName}</span>} */}
                                </div>

                                <div className="form-group col-md-12 grid-margin stretch-card">
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={editorData}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setEditorData(data);
                                        }}
                                    />

                                </div>





                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h4 className="card-title mb-0">Create Group</h4>
                                    {/* <button className="btn btn-primary" onClick={handleGroupSubmit}>Save</button> */}
                                </div>
                                {/* <p className="card-description"> Basic form layout </p> */}

                                <div className="form-group">
                                    <label >Group Name</label>

                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
